module.exports = __webpack_public_path__ + "img/201-Noir Cendre Lisse.jpg";